import axios from '@/axios';

export default {
  async getAllReportingCategory(_context, data){
    try {
      const response = await axios.get('/api/v1/admins/reporting-category/all/list', { params: data });
      return response.data.data;
    } catch (error) {
      return error;
    }
  },
  async addCategory(_context, data) {
    try {
      const response = await axios.post('/api/v1/admins/reporting-category/create', data);
      return response;
    } catch (error) {
      return error;
    }
  },
  async getParentReportingCategoryList() {
    try {
      const response = await axios.get('/api/v1/admins/reporting-category/list');
      return response;
    } catch (error) {
      return error;
    }
  },
  async getCategoryDetails(_context, data) {
    try {
      const response = await axios.get('/api/v1/admins/reporting-category/details/' + data);
      return response;
    } catch (error) {
      return error;
    }
  },
  async updateCategoryDetails(_context,data){
    try {
      const response = await axios.post('/api/v1/admins/reporting-category/update/' + data.id, data.info);
      return response;
    } catch (error) {
      return error;
    }
  },
  async deleteReportingCategoryById(_context,id){
    try {
      const response = await axios.delete('/api/v1/admins/reporting-category/delete/' + id);
      return response;
    } catch (error) {
      return error;
    }
  },
};
